import React from "react";
import { Navigate } from "react-router-dom";
import ChatAgent from "pages/chat-agent";
import { Domain, useDomain } from "utils/stage-utils";

const ChatAgentGuard: React.FC = () => {
  const domain = useDomain();
  if (domain === Domain.PROD) return <Navigate to="/" replace />;
  return <ChatAgent />;
};

export default ChatAgentGuard;
